import apiClient from "@/api/client";

export const getGallery = () => {
  return apiClient.request({
    method: "GET",
    url: `api/gallery?populate=Showcases.images&pagination[pageSize]=100`,
  });
};
